import {createContext, useContext, useState} from 'react'
import {css} from '@emotion/react'

const SecondarySideBarContext = createContext()

export const SecondarySideBarProvider = ({children}) => {
    const ctx = useState(null)

    return (
        <SecondarySideBarContext.Provider value={ctx}>
            {children}
        </SecondarySideBarContext.Provider>
    )
}

export const useSecondarySideBarContext = () => useContext(SecondarySideBarContext)

const cssSecondarySideBar = css({
    width: 400,
    borderLeft: '1px solid #e8e8e8',
    overflow: 'hidden',
})

export const SecondarySideBar = props => {
    const [content] = useSecondarySideBarContext()

    if (! content) {
        return null
    }

    return (
        <div
            css={cssSecondarySideBar}
            {...props}
        >
            {content}
        </div>
    )
}
